import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'ms-score-card',
    templateUrl: 'score-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ScoreCardComponent {
    @Input() eventId: string;
    @Input() participant1Score?: string;
    @Input() participant2Score?: string;
    @Input() showSeparator = true;

    @HostBinding('class') className = 'score-card';
}
